import { render, staticRenderFns } from "./templater-library.vue?vue&type=template&id=49c60b44&scoped=true&"
import script from "./templater-library.vue?vue&type=script&lang=js&"
export * from "./templater-library.vue?vue&type=script&lang=js&"
import style0 from "./templater-library.vue?vue&type=style&index=0&id=49c60b44&prod&scoped=true&lang=scss&"
import style1 from "./templater-library.vue?vue&type=style&index=1&id=49c60b44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c60b44",
  null
  
)

export default component.exports